import { useMemo } from 'react';

import type { InteractiveElementChipDescriptor } from '../elementChipsTypes';

/**
 * Resolves local edit state and edit lifecycle callbacks for rendered chips.
 */
export const useElementChipEditing = ({
    chips,
    editingChipId,
    setEditingChipId,
}: {
    chips: InteractiveElementChipDescriptor[];
    editingChipId: string | null;
    setEditingChipId: (chipId: string | null) => void;
}): InteractiveElementChipDescriptor[] =>
    useMemo(
        () =>
            chips.map((chip) => {
                const typeOwnedEditingChange = chip.interaction.onEditingChange;
                const typeOwnedCancelEdit = chip.interaction.onCancelEdit;

                return {
                    ...chip,
                    interaction: {
                        ...chip.interaction,
                        isEditing: editingChipId === chip.id,
                        onEditingChange: (isEditing: boolean) => {
                            if (isEditing) {
                                if (!chip.interaction.canActivate) return;

                                chip.interaction.onSelect?.();
                                setEditingChipId(chip.id);
                                typeOwnedEditingChange?.(true);
                                return;
                            }

                            typeOwnedEditingChange?.(false);
                            setEditingChipId(null);
                        },
                        onCancelEdit: () => {
                            typeOwnedCancelEdit?.();
                            setEditingChipId(null);
                        },
                    },
                };
            }),
        [editingChipId, chips, setEditingChipId],
    );
